import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  FormGroup,
  Label,
  InputGroup,
  Col,
  Row,
} from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';

import BusinessApi from 'apis/Business';
import PlansApi from 'apis/Plans';
import MultiSelectField from 'components/businesses/MultiSelectField';
import Toaster from 'components/Toaster';
import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import { showFormErrors, showInputError } from 'utils/formvalidate.js';
import 'assets/scss/formvalidate.css';

import SelectPlan from './SelectPlan';

class BusinessAddInformation extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      description: '',
      website: '',
      category_ids: [],
      categories: [],
      categoryError: '',
      contact_first_name: '',
      contact_last_name: '',
      contact_email: '',
      logo: '',
      locations_attributes: [],
      reward: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: '',
      primary_number: '',
      headquarter: true,
      plan_subscription: {},
      plan_subscription_attributes: {
        start_date: new Date(),
        end_date: '',
        status: 0,
        plan_id: 2,
      },
      isChecked: false,
      plans: [],
      trialLength: 7,
    };
  }

  componentDidMount() {
    this.fetchPlans();
  }

  addNewBusiness = () => {
    const {
      name,
      description,
      website,
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      primary_number,
      reward,
      category_ids,
      contact_first_name,
      contact_last_name,
      contact_email,
    } = this.state;
    const { history } = this.props;

    const plan_subscription_attributes = this.getPlanSubscription();

    const newBusinessData = {
      business: {
        name,
        description,
        website,
        address_line_1,
        address_line_2,
        city,
        state,
        zip,
        primary_number,
        rewards_attributes: [{ title: reward }],
        plan_subscription_attributes,
        category_ids: category_ids.split(','),
        contact_attributes: {
          first_name: contact_first_name,
          last_name: contact_last_name,
          email: contact_email,
        },
      },
    };

    BusinessApi.addNew(newBusinessData)
      .then(({ data }) => {
        Toaster.getSuccessToaster(
          'check-circle',
          `Business ${name} created successfully`
        );
        history.push(insertIdtoUrl(ROUTES.USERS_LIST, data.id));
      })
      .catch(error => {
        Toaster.getFailureToaster(
          error,
          'exclamation-triangle',
          'Something went wrong'
        );
      });
  };

  fetchPlans = () => {
    PlansApi.getAll()
      .then(({ data }) => {
        const plan_subscription = { label: data[0].title, value: data[0] };
        this.setState({ plans: data, plan_subscription });
      })
      .catch();
  };

  getPlanSubscription = () => {
    const { plan_subscription, trialLength } = this.state;
    const startDate = new Date();
    const endDate = moment(startDate).add(trialLength, 'days');

    const plan_subscription_attributes = {
      start_date: startDate,
      end_date: endDate,
      plan_id: plan_subscription.value.id,
      status: 'active',
    };

    return plan_subscription_attributes;
  };

  handleCheckBox = () => {
    const { isChecked } = this.state;

    this.setState({ isChecked: !isChecked }, () => this.handleOnCheck());
  };

  handleChange = e => {
    const _state = {};
    _state[e.target.name] = e.target.value;

    this.setState(_state);
  };

  handleFocusOut = e => {
    e.target.classList.add('active');
    showInputError(this, e.target.name);
  };

  handleFocusOutCategory = e => {
    const { category_ids } = this.state;
    let categoryError =
      category_ids.length === 0 ? 'At least one category is required' : '';
    this.setState({ categoryError });
  };

  handleOnCheck = () => {
    const { isChecked, plan_subscription_attributes } = this.state;
    const { start_date } = plan_subscription_attributes;
    const currentDate = new Date();
    let endDate = '';
    let planId = 2;

    if (isChecked) {
      const endDateInUnix = currentDate.setDate(currentDate.getDate() + 7);
      endDate = new Date(endDateInUnix);
      planId = 1;
    }

    this.setState({
      plan_subscription_attributes: {
        start_date,
        end_date: endDate,
        plan_id: planId,
      },
    });
  };

  handlePlanSelect = plan => {
    this.setState({ plan_subscription: plan });
  };

  handleSelectChange = category_ids => {
    this.setState({ category_ids });
  };

  handleSubmit = e => {
    e.preventDefault();
    const inputs = this.refs.businessAddForm.querySelectorAll('.form-control');
    const { category_ids } = this.state;

    if (!showFormErrors(this, inputs)) {
      toast.warn(() => (
        <div>
          <FontAwesomeIcon icon="exclamation-triangle" />
          Missing some informations
        </div>
      ));
    } else {
      if (category_ids.length === 0) {
        this.handleFocusOutCategory();
        toast.warn(() => (
          <div>
            <FontAwesomeIcon icon="exclamation-triangle" />
            Missing some informations
          </div>
        ));
      } else {
        this.addNewBusiness();
        window.scroll(0, 0);
      }
    }
  };

  onTrialLengthSelected = e => {
    const { value } = e.target;
    this.setState({ trialLength: value });
  };

  render() {
    const {
      name,
      description,
      website,
      category_ids,
      categoryError,
      plans,
      plan_subscription,
      trialLength,
    } = this.state;
    const currentDate = new Date();
    const endDateInUnix = currentDate.setDate(currentDate.getDate() + 7);

    return (
      <div className="business-add container">
        <form ref="businessAddForm" name="businessValidate" id="form-validate" validate="true">
          <FormGroup tag="fieldset">
            <h5> Business Information </h5>
            <FormGroup>
              <Label for="businessName" id="nameLabel">
                Name of the business
              </Label>
              <input
                className="form-control"
                type="text"
                value={name}
                onChange={this.handleChange}
                onBlur={this.handleFocusOut}
                name="name"
                ref="name"
                id="businessName"
                required
              />
              <div className="row error" id="nameError" />
            </FormGroup>
            <FormGroup>
              <Label for="businessDescription" id="descriptionLabel">
                Short Description
              </Label>
              <textarea
                className="form-control"
                type="textarea"
                value={description}
                name="description"
                id="businessDescription"
                onChange={this.handleChange}
                onBlur={this.handleFocusOut}
                ref="description"
                required
              />
              <div className="row error" id="descriptionError" />
            </FormGroup>
            <FormGroup>
              <Label for="businessWebsite" id="websiteLabel">
                Website of business
              </Label>
              <InputGroup>
                <input
                  className="form-control"
                  type="text"
                  value={website}
                  name="website"
                  id="businessWebsite"
                  onChange={this.handleChange}
                  onBlur={this.handleFocusOut}
                  ref="website"
                  required
                  pattern="^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$"
                />
              </InputGroup>
              <div className="row error" id="websiteError" />
            </FormGroup>
            <FormGroup>
              <Label>Category of Business</Label>
              <MultiSelectField
                handleSelectChange={this.handleSelectChange}
                value={category_ids}
                name="category"
                ref="category"
                handleFocusOutCategory={this.handleFocusOutCategory}
              />
              <div className="row error" id="categoryError">
                {categoryError}
              </div>
            </FormGroup>
          </FormGroup>

          <FormGroup tag="fieldset">
            <h5> Primary Contact Person </h5>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="contactFirstName" id="contact_first_nameLabel">
                    First Name
                  </Label>
                  <input
                    className="form-control"
                    type="text"
                    name="contact_first_name"
                    id="contactFirstName"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="contact_first_name"
                  />
                  <div className="row error" id="contact_first_nameError" />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="contactLastName" id="contact_last_nameLabel">
                    Last Name
                  </Label>
                  <input
                    className="form-control"
                    type="text"
                    name="contact_last_name"
                    id="contactLastName"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="contact_last_name"
                  />
                  <div className="row error" id="contact_last_nameError" />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="contactEmail" id="contact_emailLabel">
                Email Address
              </Label>
              <input
                className="form-control"
                type="email"
                name="contact_email"
                id="contactEmail"
                onChange={this.handleChange}
                onBlur={this.handleFocusOut}
                ref="contact_email"
              />
              <div className="row error" id="contact_emailError" />
            </FormGroup>
          </FormGroup>

          <FormGroup tag="fieldset">
            <h5> Primary Contact Location (Main Branch) </h5>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="businessAddress1" id="address_line_1Label">
                    Address Line 1
                  </Label>
                  <input
                    className="form-control"
                    type="text"
                    name="address_line_1"
                    id="businessAddress1"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="address_line_1"
                    required
                  />
                  <div className="row error" id="address_line_1Error" />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="businessAddress2" id="address_line_2Label">
                    Address Line 2
                  </Label>
                  <input
                    className="form-control"
                    type="text"
                    name="address_line_2"
                    id="businessAddress2"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="address_line_2"
                  />
                  <div className="row error" id="address_line_2Error" />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="businessCity" id="cityLabel">
                    City
                  </Label>
                  <input
                    className="form-control"
                    type="text"
                    name="city"
                    id="businessCity"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="city"
                    required
                  />
                  <div className="row error" id="cityError" />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Col>
                    <Label for="businessState" id="stateLabel">
                      State
                    </Label>
                  </Col>
                  <input
                    className="form-control"
                    type="text"
                    name="state"
                    id="businessState"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="state"
                    required
                  />
                  <div className="row error" id="stateError" />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="businessZip" id="zipLabel">
                    Zip
                  </Label>
                  <input
                    className="form-control"
                    type="text"
                    name="zip"
                    id="businessZip"
                    onChange={this.handleChange}
                    onBlur={this.handleFocusOut}
                    ref="zip"
                    required
                    pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                  />
                  <div className="row error" id="zipError" />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="businessPhone" id="primary_numberLabel">
                Primary Phone Number
              </Label>
              <input
                className="form-control"
                type="tel"
                type="text"
                name="primary_number"
                id="businessPhone"
                onChange={this.handleChange}
                onBlur={this.handleFocusOut}
                ref="primary_number"
                required
              />
              <div className="row error" id="primary_numberError" />
            </FormGroup>
            <SelectPlan
              handleCheckBox={this.handleCheckBox}
              plans={plans}
              plan_subscription={plan_subscription}
              handlePlanSelect={this.handlePlanSelect}
              onTrialLengthSelected={this.onTrialLengthSelected}
              trialLength={trialLength}
              isChangePlanVisible
            />
          </FormGroup>
        </form>

        <Form>
          <NavLink className="btn btn-light btn-add" to={ROUTES.BUSINESS_INDEX}>
            Cancel
          </NavLink>
          <Button className="btn-add" onClick={this.handleSubmit}>
            Create Client
          </Button>
        </Form>
      </div>
    );
  }
}

BusinessAddInformation.propTypes = {
  history: PropTypes.object,
};

export default BusinessAddInformation;



// WEBPACK FOOTER //
// ./src/components/businesses/BusinessAddInformation.js